import React from 'react';
import { useTranslation } from 'react-i18next';
import type { CampaignPanelInfo } from '../../../MultiViewCampaignSection/types';
import PrizeFundCampaign from '../../../shared/PrizeFundCampaign/PrizeFundCampaign';
import { getCarouselTopper } from 'features/campaigns/mocks/campaignMockData';
import campaignsCarouselStyles from '../css/CampaignsCarousel.module.css';

interface CarouselHeaderProps {
  hasMany: boolean;
  panelInfo: CampaignPanelInfo;
  titleRef: React.Ref<HTMLSpanElement>;
  scale: number;
}

const CarouselHeader: React.FC<CarouselHeaderProps> = ({ hasMany, panelInfo, titleRef, scale }) => {
  const { t } = useTranslation();

  if (!hasMany) return null;

  return (
    <div
      style={{ backgroundImage: `url(${getCarouselTopper(panelInfo.type)})` }}
      className={campaignsCarouselStyles.carouselTopper}
    >
      <span
        ref={titleRef}
        className={campaignsCarouselStyles.carouselTopperTitle}
        style={{
          transform: scale < 1 ? `scale(${scale})` : undefined,
        }}
      >
        {t('campaigns.prize_pool', 'Prize Pool')}
      </span>
      <PrizeFundCampaign
        amount={panelInfo.prizeFund}
        currency={panelInfo.prizeCurrency || ''}
        variant="prize-pool"
      />
    </div>
  );
};

export default CarouselHeader;
